import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppRoutes } from './routes';
import { CookieConsent } from '@/components/CookieConsent';
import { initializeTheme } from '@/components/ThemeToggle';
import { useAuthStore } from '@/stores/authStore';
import './styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 2,
    },
  },
});

function App() {
  const initializeSession = useAuthStore((state) => state.initializeSession);

  useEffect(() => {
    initializeTheme();
    void initializeSession();
  }, [initializeSession]);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppRoutes />
        <CookieConsent onAccept={() => console.log('Cookies accepted')} />
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
